import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { MemberService } from 'src/app/component/members/member-service/member.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-mark-members-as-primary-modal',
  templateUrl: './mark-members-as-primary-modal.component.html',
  styleUrls: ['./mark-members-as-primary-modal.component.css']
})
export class MarkMembersAsPrimaryModalComponent implements OnInit, OnDestroy {
  @Input() members
  @Output() closeModal = new EventEmitter<any>()
  memberForm: FormGroup
  primaryMembers;
  submitted = false;
  selectedMember: any;
  preCooperates = {};
  preSpaceTypes= {};
  preLevelOfServices = {};

  constructor(
    private memberService: MemberService,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    console.log("Selected", this.members);
    this.memberForm = this.fb.group({
      memberId: ['', Validators.required]
    });
    this.getMembers();
    this.getFundingSourceList();
    this.getSpaceTypes();
    this.getLevelOfService();
  }

  getMembers() {
    const queryParams = {
      accountStatus: 'active'
    }
    this.memberService
      .getMembers(queryParams)
      .subscribe(data => {
        if (data) {
          this.primaryMembers = data;
        }
      });
  }

  getFundingSourceList() {
      this.corporateService
        .getCorporateUsers('active')
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data ) {
            this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});        }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});   
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  save() {
    this.submitted = true;
    if (this.memberForm.invalid) {
      return;
    }
    sweetAlert('Alert', 'Are you sure you want mark the member as primary?', 'warning', 'Yes', 'No')
      .then((result) => {
        if (result.value) {
          const memberIds = this.members
            .filter(member => !member.isPrimary)
            .map(m => m._id);
          
          const payload = {
            primary: this.memberForm.value.memberId,
            secondaries: memberIds
          }
          this.memberService
            .markMembersAsPrimary(payload)
            .subscribe((data) => {
              if (data) {
                this.closeModal.emit(memberIds);
              }
            }, err => {
              sweetAlert('Error', err, 'error', 'Ok');
            });
        }
      });
  }

  remove(member) {
    if (member.isPrimary) {
      this.memberForm.patchValue({
        memberId: ''
      });
    }
    this.members = this.members.filter(m => m._id !== member._id);
  }

  setPrimaryMember(member) {
    // this.primaryMembers.find(m => m._id === member._id)
    this.selectedMember = member;
    this.members.forEach(member => member.isPrimary = false);
    member.isPrimary = true;
    this.memberForm.patchValue({
      memberId: member._id
    });
  }

  get form() {
    return this.memberForm.controls;
  }

  ngOnDestroy() {
  }
}
